import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, LowerCasePipe} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
// 3-rd party modules
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {TextMaskModule} from 'angular2-text-mask';
// module
import {SharedModule} from 'src/app/shared/shared.module';
// containers
import {RestaurantGroupComponent} from './container/restaurant-group.component';

const routes: Routes = [{path: '', component: RestaurantGroupComponent}];

@NgModule({
  declarations: [
    RestaurantGroupComponent
  ],
  providers: [DatePipe, LowerCasePipe],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    IonicModule,
    SharedModule,
    FormsModule,
    CurrencyMaskModule,
    TextMaskModule
  ],
  exports: []
})
export class RestaurantGroupModule {
}
